(() => {
  const GIFT_COLLECTION = 'promo-gift-collection';
  const giftHandles = new Set();
  
  // Smart Polling State
  let isPolling = false;
  let lastCartHash = '';

  async function loadGiftHandles() {
    if (giftHandles.size) return;
    try {
      const res = await fetch(`/collections/${GIFT_COLLECTION}/products.json?limit=250`);
      const data = await res.json();
      data.products.forEach(p => giftHandles.add(p.handle));
    } catch (e) {
      console.warn("Failed to load gift collection", e);
    }
  }

  async function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
  }

  // UPDATED: Checks for hidden property first, falls back to handles
  function eligibleQty(cart) {
    return cart.items.reduce((total, item) => {
      const hasGiftProperty = item.properties && item.properties['_is_free_gift'] === 'true';
      const isInGiftCollection = giftHandles.has(item.handle);

      if (hasGiftProperty || isInGiftCollection) {
        return total; // Exclude gift items from the count
      }
      return total + item.quantity;
    }, 0);
  }

  async function clean() {
    // 1. Throttle background tabs and prevent overlapping requests
    if (document.hidden || isPolling) return;
    
    isPolling = true;

    try {
      await loadGiftHandles();
      const cart = await getCart();

      // 2. State Hashing: Only process logic if the cart actually changed
      const currentHash = `${cart.item_count}-${cart.total_price}`;
      if (currentHash === lastCartHash) {
        isPolling = false;
        return; 
      }

      const qty = eligibleQty(cart);
      const updates = {};
      let requiresCleanup = false;

      // 3. Evaluate cart items
      cart.items.forEach(item => {
        const hasGiftProperty = item.properties && item.properties['_is_free_gift'] === 'true';
        
        if (hasGiftProperty || giftHandles.has(item.handle)) {
          // Lowest tier requirement is 3. If below, wipe the gifts.
          if (qty < 3) {
            updates[item.variant_id] = 0;
            requiresCleanup = true;
          }
        }
      });

      // 4. Execute cleanup
      if (requiresCleanup) {
        await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });

        // Update hash so we don't enter an infinite cleanup loop
        const updatedCart = await getCart();
        lastCartHash = `${updatedCart.item_count}-${updatedCart.total_price}`;

        // If they are physically on the cart page when this happens, force a reload to fix the UI
        if (location.pathname.startsWith('/cart')) {
          window.location.reload();
        } else {
          // Optional: Dispatch native theme event here if using an Ajax drawer
          // document.dispatchEvent(new CustomEvent('cart:updated'));
        }
      } else {
        // Cart is valid, just update the known state
        lastCartHash = currentHash;
      }

    } catch (error) {
      console.warn('Free gift cleanup poll failed:', error);
    } finally {
      isPolling = false;
    }
  }

  // Poll every 1.5s
  setInterval(clean, 1500);
})();